export const DOCUMENT_IMPORTER_LIST_MODALS = {
  create: 'create',
};


export const SKIP_LABEL =   {
  label: 'Skip',
  value: 'skip',
}


export const DOCUMENT_FILE_MAX_SIZE = 1024 * 1024 * 5;
